import { forwardRef } from 'react';

import clsx from 'clsx';

export const WrappedTextArea = forwardRef<
  HTMLTextAreaElement,
  JSX.IntrinsicElements['textarea'] & {
    label?: string;
    error?: string | boolean;
    wrappedClassName?: string;
    innerClassName?: string;
    isOnModal?: boolean;
    resize?: boolean;
  }
>(function WrappedInput(
  {
    error,
    className,
    wrappedClassName,
    innerClassName,
    label,
    isOnModal,
    resize,
    ...props
  },
  ref
) {
  return (
    <div className={clsx(className, 'flex flex-col gap-y-1')}>
      <div
        className={clsx(
          'outline-brand relative max-h-full rounded outline-1 focus-within:outline',
          wrappedClassName
        )}
      >
        <textarea
          {...props}
          className={clsx(
            `dark:text-gray-light peer h-full max-h-full w-full rounded border
            border-gray-200 p-2 focus:outline-none`,
            `bg-white focus:border-transparent disabled:bg-gray-100 disabled:text-gray-500
            dark:disabled:bg-gray-600 dark:disabled:text-gray-500`,
            !resize && 'resize-none',
            !isOnModal
              ? 'dark:border-gray-600 dark:bg-gray-700'
              : `dark:border-zinc-500 dark:bg-gray-600 dark:disabled:border-gray-600
                dark:disabled:bg-gray-700`,
            error &&
              `shadow-[inset_0px_0px_0px_1.5px_theme(colors.red.300)]
              dark:shadow-[inset_0px_0px_0px_1.5px_theme(colors.red.500)]`,
            innerClassName
          )}
          ref={ref}
        />

        <label
          htmlFor={props.id}
          className={clsx(
            `absolute -top-2 left-2 z-10 max-w-full truncate text-xs font-semibold
            text-gray-700 before:absolute before:top-1/3 before:-z-10 before:h-1
            before:w-full peer-disabled:bg-transparent peer-disabled:text-gray-500
            dark:text-white dark:peer-disabled:text-gray-400`,
            !isOnModal
              ? 'before:bg-white dark:before:bg-gray-800'
              : 'before:bg-[#fbfbfb] dark:before:bg-gray-700'
          )}
        >
          {label}
        </label>
      </div>
      {typeof error === 'string' && (
        <p className="text-xs font-semibold text-red-500 dark:text-red-300">
          {error}
        </p>
      )}
    </div>
  );
});
